import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { ProductListAction } from "../ProductList";
import { PageSizeStatus } from "../ProductListTypes";

const options = [
  { text: "1", value: PageSizeStatus.One },
  { text: "5", value: PageSizeStatus.Five },
  { text: "10", value: PageSizeStatus.Ten },
  { text: "25", value: PageSizeStatus.TwentyFive },
  { text: "50", value: PageSizeStatus.Fifty },
];

export type Props = {
  pageSize: string;
  onProductListAction: (action: ProductListAction, value: string) => void;
};

export const RowSelectorMenuItem: React.FC<Props> = ({
  pageSize,
  onProductListAction,
}) => {
  const trigger = (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem" }}
    >
      <Icon name="list alternate outline" size="large" />
      <span>Documents per page</span>
      <Icon name="dropdown" fitted />
    </span>
  );

  return (
    <Dropdown
      data-testid="row-selector-menu-item"
      icon={false}
      trigger={trigger}
      floating
      item
      upward={false}
    >
      <Dropdown.Menu>
        <Dropdown.Header content="Select rows" />
        {options.map(({ text, value }) => (
          <Dropdown.Item
            text={text}
            value={value}
            key={value}
            selected={pageSize === value}
            onClick={(): void =>
              onProductListAction(
                ProductListAction.ChangePageSize,
                value as string
              )
            }
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
